// import store from '@/store'

// A sentence for the user even when the server sends no `message` (gateway timeouts,
// HTML error pages, bare JSON strings, network failures) - otherwise the toast is blank.
function errorMessage (err) {
  if (!err.response) {
    if (err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT') {
      return 'The server took too long to answer (request timed out).'
    }
    return 'Could not reach the server. Check your network connection and try again.'
  }
  const { status, statusText, data } = err.response
  if (data && typeof data.message === 'string' && data.message) {
    return data.message
  }
  if (typeof data === 'string' && data.trim() && data.length < 300 && !data.trim().startsWith('<')) {
    return data
  }
  return `Server error ${status}${statusText ? ' ' + statusText : ''}`
}

// Keeps the response details on the error for callers that need more than the message.
function withResponse (error, err) {
  error.status = err.response && err.response.status
  error.data = err.response && err.response.data
  error.code = err.code
  return error
}

export default function setup (axiosInstance) {
  axiosInstance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
      // Do something before request is sent
      config.headers.Authorization =
   'Bearer ' + localStorage.getItem('token')
    }

    return config
  }, function (error) {
    // Do something with request error
    return Promise.reject(error)
  })
  axiosInstance.interceptors.response.use(undefined, function (err) {
    if (err.response && err.response.status === 401) {
      // console.log('Unauthorized')
      // if you ever get an unauthorized, logout the user
      window.location = '/login'
      // Reject so callers stop here instead of carrying on with an undefined response.
      return Promise.reject(withResponse(new Error('Your session has expired, please log in again.'), err))
    } else if (err.response && err.response.status === 404) {
      return Promise.reject(withResponse(new Error('Resource not found.'), err))
    } else {
      return Promise.reject(withResponse(new Error(errorMessage(err)), err))
    }
  })
}
